import { Routes } from '@angular/router';
import { HomePageComponent } from './pages/home-page/home-page';
import { HrPageComponent } from './pages/hr-page/hr-page';
import { SalesPageComponent } from './pages/sales-page/sales-page';
import { CrmPageComponent } from './pages/crm-page/crm-page';
import { InventoryPageComponent } from './pages/inventory-page/inventory-page';
import { AccountingPageComponent } from './pages/accounting-page/accounting-page';
import { ProcurementPageComponent } from './pages/procurement-page/procurement-page';
import { ManufacturingPageComponent } from './pages/manufacturing-page/manufacturing-page';
import { FindAPartnerComponent } from './pages/find-a-partner/find-a-partner';
import { BecomeAPartnerComponent } from './pages/become-a-partner/become-a-partner';
import { CompanyComponent } from './pages/company/company';
import { JobsComponent } from './pages/jobs/jobs';
import { EventsComponent } from './pages/events/events';
import { CustomersComponent } from './pages/customers/customers';
import { BlogsComponent } from './pages/blogs/blogs';
import { SecurityComponent } from './pages/security/security';
import { ProductPageComponent } from './pages/product-page/product-page';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy';
import { SubscriptionAgreementComponent } from './pages/subscription-agreement/subscription-agreement';
import { PricingPageComponent } from './pages/pricing-page/pricing-page';
import { HelpPageComponent } from './pages/help-page/help-page';
import { BusinessPageComponent } from './pages/business-page/business-page';
import { RegisterPageComponent } from './pages/register-page/register-page';
import { BuyNowPageComponent } from './pages/buy-now-page/buy-now-page';

export const routes: Routes = [
  { path: '', component: HomePageComponent },
  { path: 'product', component: ProductPageComponent },
  { path: 'register', component: RegisterPageComponent },
  { path: 'buy-now', component: BuyNowPageComponent },
  { path: 'hr', component: HrPageComponent },
  { path: 'sales', component: SalesPageComponent },
  { path: 'crm', component: CrmPageComponent },
  { path: 'inventory', component: InventoryPageComponent },
  { path: 'accounting', component: AccountingPageComponent },
  { path: 'procurement', component: ProcurementPageComponent },
  { path: 'manufacturing', component: ManufacturingPageComponent },
  { path: 'find-a-partner', component: FindAPartnerComponent },
  { path: 'become-a-partner', component: BecomeAPartnerComponent },
  { path: 'company', component: CompanyComponent },
  { path: 'jobs', component: JobsComponent },
  { path: 'events', component: EventsComponent },
  { path: 'customers', component: CustomersComponent },
  { path: 'blogs', component: BlogsComponent },
  { path: 'security', component: SecurityComponent },
  { path: 'pricing', component: PricingPageComponent },
  { path: 'business', component: BusinessPageComponent },
  { path: 'help', component: HelpPageComponent },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  { path: 'subscription-agreement', component: SubscriptionAgreementComponent },
  // Smart "get the app" landing for the poster QR (orderyaa.com/get-app). In production the SSR
  // server 302s mobile visitors straight to their store; this component handles desktop + fallback.
  {
    path: 'get-app',
    loadComponent: () => import('./features/get-app/get-app').then((m) => m.GetAppComponent),
  },
  {
    path: 'ordering',
    loadChildren: () => import('./features/ordering/ordering.routes').then((m) => m.ORDERING_ROUTES),
  },
  {
    path: 'rider',
    loadChildren: () => import('./features/rider/rider.routes').then((m) => m.RIDER_ROUTES),
  },
  {
    path: 'partner',
    loadChildren: () => import('./features/partner/partner.routes').then((m) => m.PARTNER_ROUTES),
  },
];
// NOTE: platform-operator store admin (approve/view/charges/payouts) lives in the ERP
// (mobilizer-platform-ui) — the product website is customer/partner/rider facing only.
